export default "__VITE_ASSET__Cp9cmS4Q__"